/**
  * This is for monitoring browser statistics. It is a wrapped Google library.
  */

/*
Copyright 2010 Google Inc.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

See the source code here:
      https://github.com/stevesouders/episodes
*/

// Don't overwrite pre-existing instances of the object (esp. for older browsers).
var EPISODES = global.EPISODES || {};
EPISODES.q = EPISODES.q || [];
EPISODES.version = "0.3";

// CUSTOMIZE THESE VARIABLES!!
EPISODES.autorun = "undefined" !== typeof EPISODES.autorun ? EPISODES.autorun : true;

EPISODES.init = function () {
  EPISODES.bDone = false;
  EPISODES.marks = {};
  EPISODES.measures = {};
  EPISODES.starts = {}; // We need to save the starts so that given a measure we can say the epoch times that it began and ended.
  EPISODES.findStartTime();
  EPISODES.addEventListener("beforeunload", EPISODES.beforeUnload, false);

  // Process any commands that have been queued up while episodes.js loaded asynchronously.
  EPISODES.processQ();

  if ("complete" == document.readyState) {
    // The page is ALREADY loaded - start EPISODES right now.
    if (performance && performance.timing && performance.timing.loadEventEnd) {
      // Fill in predefined marks from Nav Timing:
      EPISODES.mark("firstbyte", performance.timing.responseStart);
      EPISODES.mark("onload", performance.timing.loadEventEnd);
    }
    if (EPISODES.autorun) {
      EPISODES.done();
    }
  } else {
    // Start EPISODES on onload.
    EPISODES.addEventListener("load", EPISODES.onload, false);
  }
};

// Process any commands in the queue.
// The command queue is used to store calls to the API before the full script has been loaded.
EPISODES.processQ = function () {
  var len = EPISODES.q.length;
  for (var i = 0; i < len; i++) {
    var aParams = EPISODES.q[i];
    var cmd = aParams[0];
    if ("mark" === cmd) {
      EPISODES.mark(aParams[1], aParams[2]);
    } else if ("measure" === cmd) {
      EPISODES.measure(aParams[1], aParams[2], aParams[3]);
    } else if ("done" === cmd) {
      EPISODES.done(aParams[1]);
    }
  }
};

// Set a time marker (typically the beginning of an episode).
EPISODES.mark = function (markName, markTime) {
  EPISODES.marks[markName] = parseInt(markTime || new Date().getTime());

  // Special marks that we look for:
  if ("firstbyte" === markName) {
    EPISODES.measure("backend", "starttime", "firstbyte");
  } else if ("onload" === markName) {
    EPISODES.measure("frontend", "firstbyte", "onload");
    EPISODES.measure("page_load_time", "starttime", "onload");
  } else if ("done" === markName) {
    EPISODES.measure("total_load_time", "starttime", "done");
  }
};

// Measure an episode.
EPISODES.measure = function (episodeName, startNameOrTime, endNameOrTime) {
  var startEpochTime;
  if ("undefined" === typeof startNameOrTime) {
    if ("number" === typeof EPISODES.marks[episodeName]) {
      // If no startName is specified, then use the episodeName as the start mark.
      startEpochTime = EPISODES.marks[episodeName];
    } else {
      // Create a "measure" that is this exact point in time?
      startEpochTime = new Date().getTime();
    }
  } else if ("number" === typeof EPISODES.marks[startNameOrTime]) {
    // If a mark with this name exists, use that.
    startEpochTime = EPISODES.marks[startNameOrTime];
  } else if ("number" === typeof startNameOrTime) {
    // Assume a specific epoch time is provided.
    startEpochTime = startNameOrTime;
  } else {
    return;
  }

  var endEpochTime;
  if ("undefined" === typeof endNameOrTime) {
    endEpochTime = new Date().getTime();
  } else if ("number" === typeof EPISODES.marks[endNameOrTime]) {
    // If a mark with this name exists, use that.
    endEpochTime = EPISODES.marks[endNameOrTime];
  } else if ("number" === typeof endNameOrTime) {
    endEpochTime = endNameOrTime;
  } else {
    return;
  }

  EPISODES.starts[episodeName] = parseInt(startEpochTime);
  EPISODES.measures[episodeName] = parseInt(endEpochTime - startEpochTime);
};

// In the case of Ajax or post-onload episodes, call done to signal the end of episodes.
EPISODES.done = function (callback) {
  EPISODES.bDone = true;

  EPISODES.mark("done");

  if ("function" === typeof callback) {
    callback();
  }
};

// Return an object of mark names and their corresponding times.
EPISODES.getMarks = function () {
  return EPISODES.marks;
};

// Return an object of episode names and their corresponding durations.
EPISODES.getMeasures = function () {
  return EPISODES.measures;
};

// Return an object of episode names and their corresponding start times.
// This is needed so that we can determine the start and end time of a duration.
EPISODES.getStarts = function () {
  return EPISODES.starts;
};

// Use various techniques to determine the time at which this page started.
EPISODES.findStartTime = function () {
  var startTime = EPISODES.findStartWebTiming() || EPISODES.findStartCookie();
  if (startTime) {
    EPISODES.mark("starttime", startTime);
  }
};

// Find the start time from the Web Timing "performance" object.
EPISODES.findStartWebTiming = function () {
  var startTime = undefined;

  if (EPISODES.hasWebTiming()) {
    startTime = performance.timing.navigationStart;
  }

  return startTime;
};

EPISODES.hasWebTiming = function () {
  return !!(typeof performance !== 'undefined' && performance.timing && performance.timing.navigationStart);
};

// Find the start time based on a cookie set by Episodes in the unload handler.
EPISODES.findStartCookie = function () {
  var aCookies = document.cookie.split(' ');
  for (var i = 0; i < aCookies.length; i++) {
    if (0 === aCookies[i].indexOf("EPISODES=")) {
      var aSubCookies = aCookies[i].substring("EPISODES=".length).split('&');
      var startTime, bReferrerMatch;
      for (var j = 0; j < aSubCookies.length; j++) {
        if (0 === aSubCookies[j].indexOf("s=")) {
          startTime = aSubCookies[j].substring(2);
        } else if (0 === aSubCookies[j].indexOf("r=")) {
          var startPage = aSubCookies[j].substring(2);
          bReferrerMatch = EPISODES.hashCode(document.referrer) == startPage;
        }
      }
      if (bReferrerMatch && startTime) {
        return startTime;
      }
    }
  }

  return undefined;
};

// Set a cookie when the page unloads. Consume this cookie on the next page to get a "start time".
// Doesn't work in some browsers (Opera).
// This is only needed in browsers that don't support the navigation timing API (e.g. IE10-)
EPISODES.beforeUnload = function (e) {
  if (!EPISODES.hasWebTiming()) {
    document.cookie = "EPISODES=s=" + Number(new Date()) + "&r=" + EPISODES.hashCode(document.location) + "; path=/";
  }
};

// http://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
EPISODES.hashCode = function (s) {
  var hash = 0,
      i,
      chr,
      strlen = s.length;
  if (strlen === 0) {
    return hash;
  }
  for (i = 0; i < strlen; i++) {
    chr = s.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};

// When the page is done do final wrap-up.
EPISODES.onload = function (e) {
  EPISODES.mark("onload");

  if (EPISODES.autorun) {
    EPISODES.done();
  }
};

// Wrapper for addEventListener and attachEvent.
EPISODES.addEventListener = function (sType, callback, bCapture) {
  if ("undefined" != typeof window.attachEvent) {
    return window.attachEvent("on" + sType, callback);
  } else if (window.addEventListener) {
    return window.addEventListener(sType, callback, bCapture);
  }
};

module.exports = EPISODES;


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-tracking/build/episodes.js
// module id = 473
// module chunks = 168707334958949